import YourPlan from '../../Components/YourPlan/YourPlan'
import Plan from '../../Models/Plan'
import './PlanLayout.css'

interface Props
{
    plan?: Plan
    children: React.ReactNode
}

function PlanLayout(props: Props)
{
    return (
        <div className="plan-layout-container">
            <div className="plan-layout-content">
                {props.children}
            </div>
            <div className="plan-layout-plan-container" >
                {props.plan ? <YourPlan plan={props.plan} /> : <div />}
            </div>
        </div>
    )
}

export default PlanLayout